import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluck'
})
export class PluckPipe implements PipeTransform {

  transform(value: any[], key: string): string {
    return value?.map(e => e[key]).join(', ');
  }
}
